module.exports = __webpack_public_path__ + "img/climate_actions_greenenergy@2x.0cc5c53.webp";